import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./etudesPromotionnelles.scss"
export default function EtudesPromotionnelles() {
	const {setHeadband} = useContext(headbandContext)
	const {crumbs, setCrumbs} = useContext(crumbContext)
	useEffect(() => {
		setHeadband({
			title :  "Les études promotionnelles",
			icon : "picto_etudes_promotionnelles.svg",
			color : "bckRed"
		})
	}, [])
	return (
		<div id="etudesPromotionnelles" className='page'>
			<img src="/ep.png" alt="" />
			<Link to={"/accueil/drhf/fiche_contact"}
				className='cadreClique'
				onClick={() => {
                    setCrumbs([
						{
							page :'/accueil',
							title : "Accueil"
						},
						{
							page : "/accueil/drhf",
							title : "Ma DRHF"
						},
						{
							page : "/accueil/drhf/fiche_contact",
							title : "Fiche contact"
						},
					])                       
                }} 
			></Link>
		</div>
	)
}
